import TitleMobile from "./block-title-mobile";

export default TitleMobile;